export default "__VITE_ASSET__DlaeS3EI__"